import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './locales/en/translation.json';
import frTranslation from './locales/fr/translation.json';
import enAbout from './locales/en/about.json';
import frAbout from './locales/fr/about.json';
import enPromptGenerator from './locales/en/promptGenerator.json';
import frPromptGenerator from './locales/fr/promptGenerator.json';
import enScriptGenerator from './locales/en/scriptGenerator.json';
import frScriptGenerator from './locales/fr/scriptGenerator.json';
import enShared from './locales/en/shared.json';
import frShared from './locales/fr/shared.json';
import enAudioGeneration from './locales/en/audioGeneration.json';
import frAudioGeneration from './locales/fr/audioGeneration.json';
import enAudioModal from './locales/en/audioModal.json';
import frAudioModal from './locales/fr/audioModal.json';
import enAudioEditor from './locales/en/audioEditor.json';
import frAudioEditor from './locales/fr/audioEditor.json';
import enVideoEditor from './locales/en/videoEditor.json';
import frVideoEditor from './locales/fr/videoEditor.json';
import enContentCreation from './locales/en/contentCreation.json';
import frContentCreation from './locales/fr/contentCreation.json';
import enAIGenerator from './locales/en/aiGenerator.json';
import frAIGenerator from './locales/fr/aiGenerator.json';
import enCaptionEditor from './locales/en/captionEditor.json';
import frCaptionEditor from './locales/fr/captionEditor.json';
import enCaptionLandingPage from './locales/en/captionLandingPage.json';
import frCaptionLandingPage from './locales/fr/captionLandingPage.json';
import enSoundGenerator from './locales/en/soundGenerator.json';
import frSoundGenerator from './locales/fr/soundGenerator.json';
import enSoundEditor from './locales/en/soundEditor.json';
import frSoundEditor from './locales/fr/soundEditor.json';
import enTitleLandingPage from './locales/en/titleLandingPage.json';
import frTitleLandingPage from './locales/fr/titleLandingPage.json';
import enTitleDescriptionPage from './locales/en/titleDescriptionPage.json';
import frTitleDescriptionPage from './locales/fr/titleDescriptionPage.json';
import enThumbnailModal from './locales/en/thumbnailModal.json';
import frThumbnailModal from './locales/fr/thumbnailModal.json';
import enThumbnailLanding from './locales/en/thumbnailLanding.json';
import frThumbnailLanding from './locales/fr/thumbnailLanding.json';
import enThumbnailEditor from './locales/en/thumbnailEditor.json';
import frThumbnailEditor from './locales/fr/thumbnailEditor.json';
import enSocialMediaLanding from './locales/en/socialMediaLanding.json';
import frSocialMediaLanding from './locales/fr/socialMediaLanding.json';
import enSocialMediaShareModal from './locales/en/socialMediaShareModal.json';
import frSocialMediaShareModal from './locales/fr/socialMediaShareModal.json';
import enSocialMediaProjectCard from './locales/en/socialMediaProjectCard.json';
import frSocialMediaProjectCard from './locales/fr/socialMediaProjectCard.json';
import enPublishStatePill from './locales/en/publishStatePill.json';
import frPublishStatePill from './locales/fr/publishStatePill.json';
import enVerticalNav from './locales/en/verticalNav.json';
import frVerticalNav from './locales/fr/verticalNav.json';
import frMediaTab from './locales/fr/mediaTab.json';
import enMediaTab from './locales/en/mediaTab.json';
import frProcessingDashboard from './locales/fr/processingDashboard.json';
import enProcessingDashboard from './locales/en/processingDashboard.json';
import enLogin from './locales/en/login.json';
import frLogin from './locales/fr/login.json';

i18n
  .use(LanguageDetector) // Auto-detect browser language
  .use(initReactI18next)
  .init({
    resources: {
      en: { 
        translation: enTranslation,
        about: enAbout,
        promptGenerator: enPromptGenerator,
        scriptGenerator: enScriptGenerator,
        shared: enShared,
        audioGeneration: enAudioGeneration,
        audioModal: enAudioModal,
        audioEditor: enAudioEditor,
        videoEditor: enVideoEditor,
        contentCreation: enContentCreation,
        aiGenerator: enAIGenerator,
        captionEditor: enCaptionEditor,
        captionLandingPage: enCaptionLandingPage,
        soundGenerator: enSoundGenerator,
        soundEditor: enSoundEditor,
        titleLandingPage: enTitleLandingPage,
        titleDescriptionPage: enTitleDescriptionPage,
        thumbnailModal: enThumbnailModal,
        thumbnailLanding: enThumbnailLanding,
        thumbnailEditor: enThumbnailEditor,
        socialMediaLanding: enSocialMediaLanding,
        socialMediaShareModal: enSocialMediaShareModal,
        socialMediaProjectCard: enSocialMediaProjectCard,
        publishStatePill: enPublishStatePill,
        verticalNav: enVerticalNav,
        mediaTab: enMediaTab,
        processingDashboard: enProcessingDashboard,
        login: enLogin
      },
      fr: { 
        translation: frTranslation,
        about: frAbout,
        promptGenerator: frPromptGenerator,
        scriptGenerator: frScriptGenerator,
        shared: frShared,
        audioGeneration: frAudioGeneration,
        audioModal: frAudioModal,
        audioEditor: frAudioEditor,
        videoEditor: frVideoEditor,
        contentCreation: frContentCreation,
        aiGenerator: frAIGenerator,
        captionEditor: frCaptionEditor,
        captionLandingPage: frCaptionLandingPage,
        soundGenerator: frSoundGenerator,
        soundEditor: frSoundEditor,
        titleLandingPage: frTitleLandingPage,
        titleDescriptionPage: frTitleDescriptionPage,
        thumbnailModal: frThumbnailModal,
        thumbnailLanding: frThumbnailLanding,
        thumbnailEditor: frThumbnailEditor,
        socialMediaLanding: frSocialMediaLanding,
        socialMediaShareModal: frSocialMediaShareModal,
        socialMediaProjectCard: frSocialMediaProjectCard,
        publishStatePill: frPublishStatePill,
        verticalNav: frVerticalNav,
        mediaTab: frMediaTab,
        processingDashboard: frProcessingDashboard,
        login: frLogin
      }
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
